import styled from "styled-components";

export const MenuBtnStyled = styled.button`
  padding: 21px 24px;
  color: white;
  border-radius: 18px;
  font-size: 1.33333em;
  box-shadow: 0 4px 10px 0 rgba(255, 191, 29, 0.25);
  font-weight: bold;
  background-color: #ffbf1d;
  width: 100%;

  height: 72px;
`;
